import React, {Component} from 'react';
import {Panel} from 'react-bootstrap';
import ReactLoading from 'react-loading';
import {BootstrapTable, TableHeaderColumn, SearchField, ClearSearchButton} from 'react-bootstrap-table';

//const baseUrl = 'http://archivedunits.staging.civiccomputing.com/archivedunits';
//const baseUrl = 'http://localhost:8080/archived-units';
const baseUrl = 'https://www.sqa.org.uk/archivedunits';


class ArchivedUnitsSearchGrid extends Component {

  constructor(props) {

    super(props);

    this.state = {
        filter: '',
        orderBy: 'code',
        order: 'asc',
        page: 1,
        pageSize: 10,
        items: [],
        totalSize: 0,
        isDataFetched: false
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.renderTableOption = this.renderTableOption.bind(this);   
  }

  webService(filter, orderBy, order, page, pageSize) {
    this.setState({
      isDataFetched: false,
      items: []
    });
    var url = baseUrl + '/api/index/archivedunit/search';
    url += '?filter=' + filter;
    url += '&orderBy=' + orderBy;
    url += '&order=' + order;
    url += '&page=' + page;
    url += '&pageSize=' + pageSize;
    console.log('url: ' + url);
    fetch(url, { 
      method: 'GET', 
      headers: {
        'Access-Control-Request-Headers' : 'access-control-allow-origin'  
      }
    }) 
    .then((response) => response.json())
    .then((responseJson) => {
      this.setState({
        orderBy: responseJson.sort[0].property,
        order: responseJson.sort[0].direction,
        page: responseJson.number + 1,
        pageSize: responseJson.size,
        totalSize: responseJson.totalElements,
        items : responseJson.content,
        filter: filter,
        isDataFetched: true
      });      
    })
    .catch(function(error) {
      console.log('something went wrong:' + error);
    });
  }

  componentDidMount() {
    this.webService(this.state.filter, this.state.orderBy, this.state.order, this.state.page, this.state.pageSize);
  }

  handlePageChange(page, pageSize) {
    this.webService(this.state.filter, this.state.orderBy, this.state.order, page, pageSize);    
  }

  handleSearchChange(searchText, colInfos, multiColumnSearch) {
    this.webService(searchText, this.state.orderBy, this.state.order, 1, this.state.pageSize);
  }

  renderCustomSearchField = (props) => {
    return (
      <SearchField placeholder='Search for an Archived Unit'/>
    );
  }

  renderCustomClearButton = (onClick) => {
    return (
      <ClearSearchButton
        btnText='Clear'
        btnContextual='btn-info' />
    );
  }

  formatCodeColumn(cell, row) {
    return (
      <span>{row.code}&nbsp;{row.level}</span>
    );
  }

  formatFilenameColumn(cell, row) {
    var link = baseUrl + '/archivedunit/download';
    return (
      <a href={`${link}/${row.id}`} target="_blank" rel="noopener noreferrer"><button className='btn btn-success'>Download</button></a>
    );
  }

  formatTypeColumn(cell, row) {
  
  	if (row.type === 'ACD') {
		return "SQA Advanced";
    } else {
      return row.type;
    }
  }

  renderTableOption() {
    if (this.state.isDataFetched && this.state.items.length === 0) {
      return ('No Archived Units available') ;
    } else {
      return(
        <div className="loading">
          <ReactLoading type='spin' color="#444" delay={0} />         
        </div>
      );
    }
  }

  renderPaginationPanel = (props) => {
    return (
      <div>
        <div>{ props.components.pageList }</div>
      </div>
    );
  }

  render() {
    const options = {
      onPageChange: this.handlePageChange,
      onSearchChange: this.handleSearchChange,
      searchField: this.renderCustomSearchField,
      clearSearchBtn: this.renderCustomClearButton,
      paginationPanel: this.renderPaginationPanel,
      noDataText: this.renderTableOption(),
      page: this.state.page,
      clearSearch: true,
      hideSizePerPage: true,
      paginationSize: 10,
      prePage: 'Prev', 
      nextPage: 'Next', 
      firstPage: 'First', 
      lastPage: 'Last', 
      prePageTitle: 'Go to previous', 
      nextPageTitle: 'Go to next', 
      firstPageTitle: 'Go to first',
      lastPageTitle: 'Go to Last', 
      paginationPosition: 'bottom'
    };
    
    return (
      <div>
        <div className="text-center">
          <Panel header={'Archived Units Search'} bsStyle="primary">
            <BootstrapTable
              data={this.state.items}
              options={options}
              bordered= {false}
              fetchInfo={{dataTotalSize: this.state.totalSize}}
              remote
              pagination
              striped
              hover
              condensed
              search>
              <TableHeaderColumn dataField="id" dataAlign="left" isKey dataSort={false} hidden="true">Identifier</TableHeaderColumn>
              <TableHeaderColumn dataField="type" dataAlign="left" dataFormat={this.formatTypeColumn} dataSort={false}>Type</TableHeaderColumn>
              <TableHeaderColumn dataField="code" dataAlign="left" dataSort={false}>Code</TableHeaderColumn>
              <TableHeaderColumn dataField="level" dataAlign="left" dataSort={false}>Level</TableHeaderColumn>
              <TableHeaderColumn dataField="filename" dataAlign="center" dataFormat={this.formatFilenameColumn} dataSort={false}>Filename</TableHeaderColumn>
            </BootstrapTable>
          </Panel>
        </div>
      </div>
    );
  }

}

export default ArchivedUnitsSearchGrid;


// WEBPACK FOOTER //
// ./src/ArchivedUnitsApp.js